module.exports = __webpack_public_path__ + "img/al.fbaa9318.svg";